import { ConfigurationsData } from '../../../../config';
import { AppState } from '../../../app.types';
import { assert } from '@test-helpers';

type ConfigGatewayURLOptions = {
    key: keyof ConfigurationsData
    basePath?: string
};

/**
 * Derive the url for the backend api from configuration state,
 * using the gateway config key name and the endpoint url.
 * The two values are simply joined together.
 */
export function getConfigGatewayUrl (options: ConfigGatewayURLOptions) {
    return (state: AppState): string => {
        const { data } = state.configuration;
        const gatewayBaseURL = data?.[options.key];

        assert(typeof gatewayBaseURL === 'string',
            `Configuration key ${options.key} value is not found`
        );

        const url = gatewayBaseURL + options.basePath || '';

        return url;
    };
}
